import React from "react";
import { Form, Row, Col } from 'react-bootstrap';
import { Backspace }  from 'tabler-icons-react'; 

class Keyboard extends React.Component {
    render() {

        return (
            <div className="popup">

                {/* the specific input */}
                <div className="keyinvalue fade-in2">
                    <Form>
                        {/* <Form.Group as={Row} controlId="groupspecifInputPopUp" className="fade-in2"> */}
                        <Form.Group as={Row} controlId="groupspecifInputPopUp">
                            <Form.Label column lg="4" className="fcolorWhite keyInputVal"> Visitor ID</Form.Label>
                            <Col lg="8">
                                <Form.Control type="input" size="lg" placeholder="" className="keyInputVal" />
                            </Col>
                        </Form.Group>
                    </Form>
                </div>
                

                {/* SHADE */}
                <div className="popupBox fade-in1"></div>

                {/* Keyboard */}
                <div className="popupin slide-in-bottom3"> 
                    <ul>
                        <li><button type="button" alt="1" lable="1" className="keyBtns"> 1 </button></li>
                        <li><button type="button" alt="2" lable="2" className="keyBtns"> 2 </button></li>
                        <li><button type="button" alt="3" lable="3" className="keyBtns"> 3 </button></li>
                        <li><button type="button" alt="4" lable="4" className="keyBtns"> 4 </button></li>
                        <li><button type="button" alt="5" lable="5" className="keyBtns"> 5 </button></li>
                        <li><button type="button" alt="6" lable="6" className="keyBtns"> 6 </button></li>
                        <li><button type="button" alt="7" lable="7" className="keyBtns"> 7 </button></li>
                        <li><button type="button" alt="8" lable="8" className="keyBtns"> 8 </button></li>
                        <li><button type="button" alt="9" lable="9" className="keyBtns"> 9 </button></li>
                        <li><button type="button" alt="0" lable="0" className="keyBtns"> 0 </button></li>
                    </ul>
                    <ul>
                        <li><button type="button" alt="Q" lable="Q" className="keyBtns"> Q </button></li>
                        <li><button type="button" alt="R" lable="W" className="keyBtns"> W </button></li>
                        <li><button type="button" alt="E" lable="E" className="keyBtns"> E </button></li>
                        <li><button type="button" alt="R" lable="R" className="keyBtns"> R </button></li>
                        <li><button type="button" alt="T" lable="T" className="keyBtns"> T </button></li>
                        <li><button type="button" alt="Y" lable="Y" className="keyBtns"> Y </button></li>
                        <li><button type="button" alt="U" lable="U" className="keyBtns"> U </button></li>
                        <li><button type="button" alt="I" lable="I" className="keyBtns"> I </button></li>
                        <li><button type="button" alt="O" lable="O" className="keyBtns"> O </button></li>
                        <li><button type="button" alt="P" lable="P" className="keyBtns"> P </button></li>
                    </ul>
                    <ul className="adjRow3">
                        <li><button type="button" alt="A" lable="A" className="keyBtns"> A </button></li>
                        <li><button type="button" alt="S" lable="S" className="keyBtns"> S </button></li>
                        <li><button type="button" alt="D" lable="D" className="keyBtns"> D </button></li>
                        <li><button type="button" alt="F" lable="F" className="keyBtns"> F </button></li>
                        <li><button type="button" alt="G" lable="G" className="keyBtns"> G </button></li>
                        <li><button type="button" alt="H" lable="H" className="keyBtns"> H </button></li>
                        <li><button type="button" alt="J" lable="J" className="keyBtns"> J </button></li>
                        <li><button type="button" alt="K" lable="K" className="keyBtns"> K </button></li>
                        <li><button type="button" alt="L" lable="L" className="keyBtns"> L </button></li>
                    </ul>
                    <ul className="adjRow4">
                        <li><button type="button" alt="Z" lable="Z" className="keyBtns"> Z </button></li>
                        <li><button type="button" alt="X" lable="X" className="keyBtns"> X </button></li>
                        <li><button type="button" alt="C" lable="C" className="keyBtns"> C </button></li>
                        <li><button type="button" alt="V" lable="V" className="keyBtns"> V </button></li>
                        <li><button type="button" alt="B" lable="B" className="keyBtns"> B </button></li>
                        <li><button type="button" alt="N" lable="N" className="keyBtns"> N </button></li>
                        <li><button type="button" alt="M" lable="M" className="keyBtns"> M </button></li>
                        <li><button type="button" alt="Delete" lable="backspace" className="keyBtns"> 
                        <Backspace size={55} strokeWidth={1} color={'gray'} />
                        </button></li>
                    </ul>
                    <ul className="adjRow5">
                        <li><button type="button" alt="Z" lable="Z" className="keyBtns spaceBtn"> Space </button></li> 
                        <li><button type="button" alt="Z" lable="Z" className="keyBtns returnBtn"> Return </button></li> 
                    </ul>


                </div>
            </div>
        );
    }
}

export default Keyboard;
